import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/50'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
            <i className="ri-movie-2-line text-background-50 text-lg"></i>
          </div>
          <span className="text-xl font-heading font-bold text-foreground-50 whitespace-nowrap">
            秋霞影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {movieCategories.map((cat) => (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === `/category/${cat.key}`
                  ? 'bg-accent-500/20 text-accent-400'
                  : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ml-2 ${
              location.pathname === '/about'
                ? 'bg-accent-500/20 text-accent-400'
                : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
            }`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
            <i className="ri-search-line text-foreground-400 text-sm"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-foreground-300 text-lg ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50 px-4 py-4">
          <div className="flex flex-col gap-1">
            {movieCategories.map((cat) => (
              <Link
                key={cat.key}
                to={`/category/${cat.key}`}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                  location.pathname === `/category/${cat.key}`
                    ? 'bg-accent-500/20 text-accent-400'
                    : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
                }`}
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-accent-500/20 text-accent-400'
                  : 'text-foreground-400 hover:text-foreground-100 hover:bg-background-100'
              }`}
            >
              <i className="ri-information-line mr-2"></i>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}